import type { SpendReconciliation as Reconciliation } from '../../api/types'

const amount = (value: number, currency = 'USD') => {
  try { return new Intl.NumberFormat(undefined, { style: 'currency', currency, maximumFractionDigits: 4 }).format(value) }
  catch { return `${value.toFixed(4)} ${currency}` }
}
const date = (value: string) => new Date(value).toLocaleDateString()

export default function SpendReconciliation({ data }: { data?: Reconciliation }) {
  return <section className="spend-reconciliation">
    <h2>Provider reconciliation</h2>
    <p className="muted">Compare imported provider totals with attributed usage. These totals are not added again to spend.</p>
    {!data ? <p className="muted">Reconciliation data is not available yet.</p> : <>
      <div className="spend-reconciliation-summary">
        <span>{data.pending_events.toLocaleString()} pending reservations</span>
        <span>{data.unpriced_events.toLocaleString()} events awaiting pricing</span>
        <span>Checked {new Date(data.as_of).toLocaleString()}</span>
      </div>
      {!data.providers.length ? <p className="muted">No provider billing totals imported yet. Usage estimates remain visible in Breakdown.</p> : <div className="table-wrap"><table className="data">
        <thead><tr><th>Provider / period</th><th>Provider total</th><th>Matched usage</th><th>Difference</th><th>Evidence</th></tr></thead>
        <tbody>{data.providers.map((row, index) => <tr key={`${row.provider}-${row.period_start}-${row.source}-${index}`}>
          <td>{row.provider}<small>{date(row.period_start)} – {date(row.period_end)}</small></td>
          <td>{amount(row.amount, row.currency)}<small>{row.estimated ? 'Estimated' : 'Provider reported'} · {row.basis.replaceAll('_', ' ')}</small></td>
          <td>{row.matched_usd == null ? 'Not matched' : amount(row.matched_usd)}</td>
          <td>{row.difference_usd == null ? 'Not comparable' : amount(row.difference_usd)}</td>
          <td>{row.source}<small>Imported {new Date(row.imported_at).toLocaleString()}</small></td>
        </tr>)}</tbody>
      </table></div>}
      <div className="table-footnote">Differences can include shared charges, billing delays, credits, and usage that has not been attributed. Company allocations remain distinct from provider totals.</div>
    </>}
  </section>
}
